import React from 'react';
import { FieldComponentProps } from 'components/anvilFormFillable/fields/types';
import InputText from 'components/common/InputText';
import { placeholderByType } from 'components/anvilFormFillable/utils';

export default function LongText({
  field,
  value,
  onChange,
  ...props
}: FieldComponentProps) {
  const placeholder = placeholderByType[field.type] ?? 'Please enter a value';
  return (
    <InputText
      {...props}
      id={field?.id ?? ''}
      key={field?.id}
      autoFocus
      placeholder={placeholder}
      value={(value?.value ?? '') as string}
      multiline
      onChange={(e) => {
        onChange?.({ ...value, value: e.target.value });
      }}
      className="w-full max-h-[50px] overflow-auto resize-y"
    />
  );
}
